import { render, staticRenderFns } from "./_realtimeRank.vue?vue&type=template&id=6f16cf28&scoped=true&"
import script from "./_realtimeRank.vue?vue&type=script&lang=js&"
export * from "./_realtimeRank.vue?vue&type=script&lang=js&"
import style0 from "./_realtimeRank.vue?vue&type=style&index=0&id=6f16cf28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f16cf28",
  null
  
)

export default component.exports